var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userSettings"},[_c('div',{staticClass:"loginOutBox",on:{"click":_vm.loginOut}},[_c('div',{staticClass:"loginOut"},[_vm._v(_vm._s(_vm.$t.auth.logout))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }